export const ALL = 'All';
export const POSTS = 'Posts';
export const COMMENTS = 'Comments';
